/** Maximum supported local option count without virtualization. */
export const SEARCH_SELECT_MAX_OPTION_COUNT = 5000;
